import {
  StyledSelect
} from "./chunk-HN4IHMQT.mjs";
import {
  __objRest,
  __spreadValues
} from "./chunk-SGYJX2RX.mjs";

// src/components/select/select-content.tsx
import { Portal, Select } from "@ark-ui/react";
import React, { forwardRef } from "react";
var SelectContent = forwardRef(
  function SelectContent2(_a, ref) {
    var _b = _a, { portalled = true, portalRef } = _b, rest = __objRest(_b, ["portalled", "portalRef"]);
    return /* @__PURE__ */ React.createElement(Portal, { disabled: !portalled, container: portalRef }, /* @__PURE__ */ React.createElement(Select.Positioner, null, /* @__PURE__ */ React.createElement(StyledSelect.Content, __spreadValues({ ref }, rest))));
  }
);

export {
  SelectContent
};
